import React, { FC } from 'react';
import { TSelectProps } from './Select.type';
import DesktopSelect from './components/DesktopSelect';
import MobileSelect from './components/MobileSelect';

const Select: FC<TSelectProps> = ({ isMobile, ...props }) =>
  isMobile ? <MobileSelect {...props} /> : <DesktopSelect {...props} />;

export { Select };
